import {z} from 'zod';
import {todoDbSchema} from './todoDbSchema';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';

export const todoSchema = todoDbSchema.omit({createdAt: true, updatedAt: true, done: true}).extend({
  id: z.string(),
  createdAt: firestoreTimestampToDateSchema,
  updatedAt: firestoreTimestampToDateSchema,
  done: firestoreTimestampToDateSchema.nullable(),
});

export type Todo = z.infer<typeof todoSchema>;
